// Адреса раздела «Дела». Раздел один и представление одно: дело — это не сущность со своим
// списком, а строка очереди, ведущая в чужой раздел с уже наложенным отбором.

import { buildPath } from '@/shared/routing/paths';

export const SECTION = 'cases';
export const VIEW_LIST = 'list';

/** Порог, после которого неотчитанные деньги считаются зависшими.
 *
 * Четырнадцать дней — то же число, что у сторожа на сервере (настройка
 * `unreported_alert_days`) и в описании панели «не отчитались дольше двух недель».
 *
 * ⚠️ Пока это второе место, где живёт число: экрана настроек ещё нет, и порог в кабинет
 * приезжать неоткуда. Как только настройки появятся в обмене, значение берётся оттуда, а эта
 * константа удаляется — иначе однажды порог поменяют на сервере, а «Дела» продолжат считать
 * по-своему, и два экрана назовут разное число людей.
 */
export const ПОРОГ_ЗАВИСАНИЯ_ДНЕЙ = 14;

export function listPath(): string {
  return buildPath({ section: SECTION, view: VIEW_LIST });
}
